import React from "react";

const CompanyView = () => {
  return <div>CompanyView</div>;
};

export default CompanyView;
